/* eslint-disable react/jsx-pascal-case */
import React, { useContext, useRef, useState } from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { SD_Context } from "./context/sd-context";
import New_Nav from "./Components/sd-navbar/sd-new-nav";
import Footer from "./Components/sd-footer/sd-footer";
import Sd_Routes from "./sd-routes";
import UserService from "./services/sd-user.service";
import Sd_error_page from "./pages/sd-error-pages/sd-error-response";
import {
  sd_event1,
  sd_event2,
  sd_event4,
  // sd_event3,
  // sd_image1,
  // sd_image2,
  // sd_image3,
  sd_masks,
  // sd_masks,
  SD_Right_Arrow_white,

  // sd_event2,
  // sd_event3,
  // sd_event4,
} from "./Assets/imageList";
// import {useIdleTimer} from "react-idle-timer";
import ErrorBoundary from "./context/sd-error-boundary";
import Sd_loading from "./Components/sd-common-components/sd-loading";
import Maintenance from "./pages/maintenance/maintenance";

const App = React.memo((props) => {
  const { setUserData, display, setDisplay, refContainer } =
    useContext(SD_Context);
  const supportedLanguages = ["en-in", "jp-in", "de-in", "es-in"];
  const templeID = process.env.REACT_APP_TEMPLE ?? "SSVVSD";
  const [loading, setLoading] = React.useState(true);
  // const timeout = 900000;
  // const [remaining, setRemaining] = useState(timeout);
  const [trig, setTrig] = useState(false);
  // const [trig2, setTrig2] = useState(false);
  const [maintenance, setMaintenance] = useState(false);

  const [selectedLanguage, setSelectedlanguage] = useState("");
  const [shift, setShift] = useState(false);
  const refe = useRef(null);
  // const refe2 = useRef(null);
  // const [display2, setDisplay2] = useState(false);
  const fetchOnlineEnable = async () => {
    const res = await UserService.getTempleConfig(templeID);
    if (!res.onlineBookingEnabled) {
      setMaintenance(true);
      setLoading(false);
      return;
    }
  };

  React.useEffect(async () => {
    if (
      supportedLanguages.includes(
        props.history?.location?.pathname?.split?.("/")?.[1],
      )
    ) {
      setSelectedlanguage(props.history?.location?.pathname?.split?.("/")?.[1]);
    } else {
      setSelectedlanguage("en-in");
    }
    fetchOnlineEnable();

    if (localStorage.getItem("accessToken")) {
      checkToken();
    } else {
      setLoading(false);
      setShift(false);
    }
  }, []);

  // React.useEffect(() => {
  //   if (remaining <= 0 && shift) {
  //     if (localStorage.getItem("accessToken")) {
  //       localStorage.clear();
  //       props.history?.push(`/`);
  //     }
  //   }
  // }, [remaining]);

  // React.useEffect(() => {
  //   setRemaining(getRemainingTime());
  //   setInterval(() => {
  //     setRemaining(getRemainingTime());
  //   }, 1000);
  // }, []);

  const checkToken = async () => {
    try {
      setLoading(true);
      if (localStorage.getItem("accessToken")) {
        // console.log("in access token");
        let data = await UserService.checkToken(templeID);
        setUserData(data);
        setShift(true);
        // if (data) {
        //   let result = await UserService.getUserDetails();
        //   setUserData(result);
        //   setShift(true);
        //   // setUserData(data);
        // }
      }
    } catch (error) {
      // console.log(error);
      localStorage.clear();
    }
    setShift(true);

    setLoading(false);
  };
  // console.log("app");
  const closeFunction = () => {
    setTimeout(() => {
      setTrig(true);
      try {
        refe.current.focus();
      } catch (e) {
        // console.log("");
      }
    }, 3000);
    setTimeout(() => {
      if (display) {
        setDisplay(false);
      }
    }, 10000);
  };

  // const closeFunction2 = () => {
  //   setTimeout(() => {
  //     // setSeconds(true);
  //     setTrig2(true);
  //     try {
  //       refe2.current.focus();
  //     } catch (e) {
  //       // console.log("");
  //     }
  //   }, 3000);
  //   setTimeout(() => {
  //     if (display2) {
  //       setDisplay2(false);
  //     }
  //   }, 10000);
  // };

  // const {getRemainingTime} = useIdleTimer({
  //   timeout,
  //   crossTab: {
  //     emitOnAllTabs: true,
  //   },
  // });

  const handleKey = (e) => {
    if (!e.target.className) {
      return;
    }
    if (e.target.className === "sd-pop-up") {
      if (trig) {
        setDisplay(false);
        // setDisplay2(true);
        setTrig(false);
      }
      // if (trig2) {
      //   setDisplay2(true);
      //   setTrig2(false);
      // }
    }
  };

  return <></>;
});
App.displayName = "Apps";

export default withRouter(App);
